import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'letter-c-small', 'IconLetterCSmall', [["path",{"d":"M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0","key":"svg-0"}]]);